export default __webpack_public_path__ + "static/media/new-cell.149307bf.png";